import _ from 'lodash';
import { AnyAction } from 'redux';
import { BackendSearchActions, BackendSearchState, BackendSearchStates, Filter, FilterOptions, FilterPill, SortFilter } from '../models/search-models';


export const defaultBackendPageSize = 15;

const defaultChangeLogSearchState: BackendSearchState = {
	seletedFilters: [],
	filterOptions: {},
	requesting: false,
	list: [],
	filterPills: [],
	sorts: [],
	currentPage: 1,
	totalPage: 0,
	totalCount: 0,
	pageSize: defaultBackendPageSize,
};

const InitialState: BackendSearchStates = {
	CHANGE_LOG: defaultChangeLogSearchState,
	BENEFIT_GROUP_CHANGE_LOG: defaultChangeLogSearchState,
};

const addFilter = (filters: Filter[], filter: Filter, replaceExisting?: boolean) => {
	if (replaceExisting) {
		const filtered = filters.filter(a => a.type !== filter.type);
		filtered.push(filter);
		const update = _.cloneDeep(filtered);
		return update;
	}

	if (!filters.some(a => a.type === filter.type && a.value === filter.value)) {
		const update = _.cloneDeep(filters);
		update.push(filter);
		return update;
	}
	return filters;
};

const removeFilter = (filters: Filter[], filter: Filter) => {
	const filtered = filters.filter(a => a.type !== filter.type || a.value !== filter.value);
	const update = _.cloneDeep(filtered);
	return update;
};


export const backendSearchReducer = (state = InitialState, action: AnyAction): BackendSearchStates => {
	const { app } = action;

	switch (action.type) {
		case BackendSearchActions.SET_LIST:
			return {
				...state,
				[app]: {
					...state[app],
					list: action.payload,
					requesting: false,
				},
			};
		case BackendSearchActions.BEGIN_REQUEST:
			return {
				...state,
				[app]: {
					...state[app],
					requesting: true,
				},
			};
		case BackendSearchActions.END_REQUEST:
			return {
				...state,
				[app]: {
					...state[app],
					requesting: false,
				},
			};
		case BackendSearchActions.SET_FILTER_OPTIONS:
			return {
				...state,
				[app]: {
					...state[app],
					filterOptions: action.payload,
				},
			};
		case BackendSearchActions.ADD_FILTER:
			return {
				...state,
				[app]: {
					...state[app],
					seletedFilters: addFilter(state[app]?.seletedFilters, action.payload, action.replaceExisting),
				},
			};

		case BackendSearchActions.REMOVE_FILTER:
			return {
				...state,
				[app]: {
					...state[app],
					seletedFilters: removeFilter(state[app]?.seletedFilters, action.payload),
				},
			};

		case BackendSearchActions.SET_FILTER_PILLS:
			return {
				...state,
				[app]: {
					...state[app],
					currentPage: 1,
					filterPills: action.payload,
				},
			};

		case BackendSearchActions.RESET_SEARCH:
			return {
				...state,
				[app]: {
					...state[app],
					seletedFilters: [],
					requesting: false,
					list: [],
					filterPills: [],
					sorts: [],
				},
			};

		case BackendSearchActions.UPDATE_SORT_FILTER:
			return {
				...state,
				[app]: {
					...state[app],
					sorts: [action.payload],
				},
			};

		case BackendSearchActions.SET_PAGINATION_INFO:
			return {
				...state,
				[app]: {
					...state[app],
					totalCount: action?.payload?.totalCount,
					totalPage: action?.payload?.totalPage,
					pageSize: action?.payload?.pageSize,
				},
			};

		case BackendSearchActions.UPDATE_PAGE:
			return {
				...state,
				[app]: {
					...state[app],
					currentPage: action?.payload,
				},
			};

		default: return state;
	}
};


export const addFilterByApp = (filter: Filter, app: string, replaceExisting?: boolean) => {
	return {
		type: BackendSearchActions.ADD_FILTER,
		payload: filter,
		app,
		replaceExisting,
	};
};

export const removeFilterByApp = (filter: Filter, app: string) => {
	return {
		type: BackendSearchActions.REMOVE_FILTER,
		payload: filter,
		app,
	};
};

export const resetSearchByApp = (app: string) => {
	return {
		type: BackendSearchActions.RESET_SEARCH,
		app,
	};
};


export const setFilterOptions = (filterOption: { [key: string]: FilterOptions }, app: string) => {
	return {
		type: BackendSearchActions.SET_FILTER_OPTIONS,
		app,
		payload: filterOption,
	};
};



export const setFilterPills = (filterPills: FilterPill[], app: string) => {
	return {
		type: BackendSearchActions.SET_FILTER_PILLS,
		app,
		payload: filterPills,
	};
};


export const updateSort = (sort: SortFilter, app: string) => {
	return {
		type: BackendSearchActions.UPDATE_SORT_FILTER,
		app,
		payload: sort,
	};
};


export const setList = (list: any[], app: string) => {
	return {
		type: BackendSearchActions.SET_LIST,
		app,
		payload: list,
	};
};

export const setPaginationInfo = (totalPage: number, totalCount: number, pageSize: number, app: string) => {
	return {
		type: BackendSearchActions.SET_PAGINATION_INFO,
		app,
		payload: { totalPage, totalCount, pageSize },
	};
};

export const setCurrentPage = (pageNumber: number, app: string) => {
	return {
		type: BackendSearchActions.UPDATE_PAGE,
		app,
		payload: pageNumber,
	};
};

export const setBeginRequest = (app: string) => {
	return {
		type: BackendSearchActions.BEGIN_REQUEST,
		app,
	};
};

export const setEndRequest = (app: string) => {
	return {
		type: BackendSearchActions.END_REQUEST,
		app,
	};
};

